<template>
  <div class="moment-content-root">
    <p class="mont-title">{{className}}</p>
    <!--
      此方案用于此组件一进来不需要向后台请求数据，自身带有图片列表数据
      loading 提示 思路方案1：
        if(图片列表数组大于0,说明有图片) {
          if(图片已经全部加载完成) { 显示 显示图片列表 };
          else(图片还没完全加载完毕) { 显示 loading }
        } else(图片列表数组等于0) {
          if(获取数据的ajax请求已经完成) { 显示 暂无图片 提示 }
          else(获取数据的ajax请求正在执行) { 显示 loading }
        }
    -->

    <!-- <template v-if="montList.length > 0">
      <div class="mont-show" v-show="loadedAmount+errorAmount >= montList.length">
        <div class="now-img">
          <div class="big-img-wrap">
            <img class="pic" :src="montList.length > 0 ? montActive.picture_address : ''">
            <div
              class="left arrow"
              @click="previousMont"
              :style="{cursor: montIdx === 0 ? 'not-allowed' : ''}"
            >
              <v-icon class="v-svg" name="chevron-left" scale="3"></v-icon>
            </div>
            <div
              class="right arrow"
              @click="nextMont"
              :style="{cursor: montIdx === Math.max(montList.length - 1, 0) ? 'not-allowed' : ''}"
            >
              <v-icon class="v-svg" name="chevron-right" scale="3"></v-icon>
            </div>
            <div class="setting">
              <div
                class="set-cover"
                @click="checkboxHandle"
                v-if="canSetCover"
              >
                <div class="checkbox">
                  <v-icon v-if="montActive.is_cover" name="check" scale="0.7"></v-icon>
                </div>
                <span>封面</span>
              </div>
              <span class="delete" @click="delMont" v-if="montActive.is_deleted">删除</span>
            </div>
          </div>
          <div class="img-desc">
            <p>{{montActive.user_name}}（{{montActive.member_type | userRole}}）上传于 {{montActive.create_time | time(false)}}</p>
            <p>
              <span class="current">{{montIdx | formateNum}}</span>
              /{{montList.length}}
            </p>
          </div>
        </div>
        <div class="moment-list-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="vuescrollOpt">
              <div class="scroll-cont">
                <div
                  v-for="(item, index) in montList"
                  :class="['mont-item', {'active' : montIdx === index} ]"
                  :key="item.sm_id"
                  @click="checkMont(index)"
                >
                  <img
                    :src="item.picture_address"
                    @load="montLoaded"
                    @error="montLoadErr(index)"
                    class="img"
                  >
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <yioks-loading v-if="loadedAmount+errorAmount < montList.length"></yioks-loading>
    </template>
    <template v-else>
      <div class="no_moment" v-if="ajaxEnd">
        <p>暂无精彩瞬间</p>
      </div>
      <yioks-loading v-else></yioks-loading>
    </template> -->

    <!--
      此方案用于此组件一进来就要向后台请求图片列表数据
      loading 提示 思路方案1：
        if(获取数据的ajax请求已经完成) {
          if(获取到的图片列表数组大于0) {
            if(图片已经全部加载完成) { 显示图片列表 };
            else(图片还没完全加载完毕) { 显示 loading }
          }
          else() { 显示 暂无图片 提示 }
        }
        else(获取数据的ajax请求正在执行) { 显示 loading }
    -->

    <template v-if="ajaxEnd">
      <template v-if="montList.length > 0">
        <!--<yioks-loading v-if="loadedAmount+errorAmount < montList.length"></yioks-loading>-->
        <!-- 下面包裹图片列表的div.mont-show不能用 v-if，因为用来v-if之后没办法检测每个图片的加载是否完成 -->
        <!--<div class="mont-show" v-show="loadedAmount+errorAmount >= montList.length">-->
        <div class="mont-show">
          <div class="now-img">
            <div class="big-img-wrap">
              <img class="pic" :src="montList.length > 0 ? montActive.picture_address : ''">
              <div
                  class="left arrow"
                  @click="previousMont"
                  :style="{cursor: montIdx === 0 ? 'not-allowed' : ''}"
              >
                <v-icon class="v-svg" name="chevron-left" scale="3"></v-icon>
              </div>
              <div
                  class="right arrow"
                  @click="nextMont"
                  :style="{cursor: montIdx === Math.max(montList.length - 1, 0) ? 'not-allowed' : ''}"
              >
                <v-icon class="v-svg" name="chevron-right" scale="3"></v-icon>
              </div>
              <div class="setting">
                <div
                    class="set-cover"
                    @click="checkboxHandle"
                    v-if="canSetCover"
                >
                  <div class="checkbox">
                    <v-icon v-if="montActive.is_cover" name="check" scale="0.7"></v-icon>
                  </div>
                  <span class="fm">封面</span>
                </div>
                <span class="delete" @click="delMont" v-if="montActive.is_deleted">删除</span>
              </div>
              <div class="preview-big-img" @click="dialogVisible = true">
                <i class="el-icon-zoom-in big-icon"></i>
                <span>查看大图</span>
              </div>
            </div>
            <div class="img-desc">
              <p>{{montActive.user_name}}（{{montActive.member_type | userRole}}）上传于 {{montActive.create_time | time(false)}}</p>
              <p>
                <!--<span class="current">{{montIdx | formateNum}}</span>-->
                <span class="current">{{montIdx+1}}</span>
                <span> / </span>
                <span>{{montList.length}}</span>
              </p>
            </div>
          </div>
          <div class="moment-list-wrap">
            <div class="scroll-wrap">
              <vue-scroll :ops="vuescrollOpt">
                <div class="scroll-cont">
                  <div
                      v-for="(item, index) in montList"
                      :class="['mont-item', {'active' : montIdx === index} ]"
                      :key="item.sm_id"
                      @click="checkMont(index)"
                  >
                    <!--<img
                        :src="item.picture_address"
                        @load="montLoaded"
                        @error="montLoadErr(index)"
                        class="img"
                    >-->
                    <img :src="item.picture_address"
                         @error="montLoadErr(index)"
                         class="img">
                    <!--<img v-lazy="item.picture_address"
                         @error="montLoadErr(index)"
                         class="img">-->
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- <div class="no_moment">
          <p>暂无精彩瞬间</p>
        </div> -->
        <yioks-empty class="empty-box" h='auto'></yioks-empty>
      </template>
    </template>
    <template v-else>
      <yioks-loading></yioks-loading>
    </template>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag"
                :tips="`确定删除该精彩瞬间吗？`"
                @hideTips="hideTipsDialog"></yioks-tips>
    <el-dialog :width="dw"
               :top="dt"
               :visible.sync="dialogVisible"
               class="preview-img">
      <img width="100%" :src="montList.length > 0 ? montActive.picture_address : ''">
    </el-dialog>
  </div>
</template>

<script>
  /* 精彩瞬间左右箭头 */
  import "vue-awesome/icons/chevron-left";
  import "vue-awesome/icons/chevron-right";
  import "vue-awesome/icons/check";
  import Icon from "vue-awesome/components/Icon";
  import {correctStatus} from "@/assets/js/apiStatus";
  import {roleType, organAccount, newRoleType,teacherAccount} from "@/assets/js/status";
  import {setMomentCover, delMoment} from "@/api/common/api";
  import {storageData} from "@/assets/js/storage";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  import errorImg from "@/assets/images/img.png";
  import Tips from "@/components/Tips/Dialog";

  export default {
    name: "MomentList",
    props: {
      classId: {
        type: [Number, String],
        required: true
      },
      list: {
        type: Array,
        required: true
      },
      ajaxEnd: {
        type: Boolean,
        required: true
      },
      className: {
        type: String,
        required: true
      },
      /*momentType: {
        type: String,
        default: ""
      },*/
      dw: {
        type: String,
        required: false,
        default: "890px"
      },
      dt: {
        type: String,
        required: false,
        default: "10vh"
      },
    },
    created() {
    },
    data() {
      const montList = this.list;
      const montIdx = montList.findIndex(({is_cover}) => !!is_cover);
      return {
        montList,
        montIdx: montIdx === -1 ? 0 : montIdx,
        // loadedAmount: 0,
        // errorAmount: 0,
        vuescrollOpt: createScrollOpt(),
        // 当前角色下是否有权限设为封面
        canSetCover: [organAccount, teacherAccount].indexOf((storageData.getUserInfo() || {}).member_type) !== -1,
        tipsFlag: false,
        dialogVisible: false,
      };
    },
    methods: {
      checkboxHandle() {
        const {montIdx, montList, montActive} = this;
        // 前台改变数组 montList 中每项 is_cover 的值，引发视图更新
        montActive.is_cover = !montActive.is_cover;
        montList.forEach((item, i) => {
          i !== montIdx && (item.is_cover = false);
        });
        // 向后台发送请求更新封面
        this.setCover({
          sm_id: montActive.sm_id,
          is_cover: montActive.is_cover ? 1 : 0
        });
      },
      previousMont() {
        this.montIdx !== 0 && --this.montIdx;
      },
      nextMont() {
        this.montIdx !== Math.max(this.montList.length - 1, 0) && ++this.montIdx;
      },
      // 当设为封面 checkbox 发生变化时执行
      checkChange(val) {
        // console.log('check change', val)
        this.setCover({
          sm_id: this.montList[this.montIdx].sm_id,
          is_cover: val ? 1 : 0
        });
      },
      // 删除精彩瞬间中的图片
      delMont() {
        this.tipsFlag = true;
      },
      hideTipsDialog(bool, sure) {
        this.tipsFlag = bool;
        if (sure) {
          const {sm_id} = this.montActive;
          delMoment({sm_id})
            .then(({data}) => {
              if (data.status === correctStatus) {
                this.$emit("getList");
                // this.$emit("getList", this.momentType); // 向父组件发送事件，让父组件重新请求接口，更新 moment 数据
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
        }
      },
      checkMont(index) {
        this.montIdx = index;
      },
      /*montLoaded() {
        ++this.loadedAmount;
      },*/
      montLoadErr(i) {
        console.log("图片加载失败");
        // ++this.errorAmount;
        this.montList[i].picture_address = errorImg;
      },
      setCover({sm_id, is_cover} = {}) {
        setMomentCover({
          c_id: this.classId,
          sm_id,
          is_cover
        }).then(({data}) => {
          if (data.status === correctStatus) {
            this.$emit("getList")
            // this.$emit("getList", this.momentType); // 向父组件发送事件，让父组件重新请求接口，更新 moment 数据
          } else {
            this.$message.error(`设置/取消 封面失败${data.msg}`);
          }
        });
      }
    },
    watch: {
      list: {
        handler(newVal) {
          this.montList = newVal;
          const montIdx = newVal.findIndex(({is_cover}) => !!is_cover);
          this.montIdx = montIdx === -1 ? 0 : montIdx;
        }
      }
    },
    computed: {
      montActive() {
        return this.montList[this.montIdx];
      },
    },
    filters: {
      /*formateNum(num) {
        return num + 1 < 10 ? "0" + (num + 1) : num + 1;
      },*/
      userRole(role) {
        return newRoleType(role);
      },
    },
    components: {
      "v-icon": Icon,
      "yioks-loading": () => import("@/components/Loading/Loading"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-tips": Tips,
    }
  };
</script>

<style lang="stylus">
  .moment-content-root {
    .preview-img {
      .el-dialog__header {
        padding: 0;
      }
      .el-dialog__body {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
<style lang="stylus">
  @import '~@/assets/css/variable'

  .moment-content-root
    position relative
    display block
    width 100%
    height 600px
    padding 30px 20px 20px
    background-color $block_bg_color_base
    .mont-title
      display block
      font-size 22px
      margin-bottom 25px
    .mont-show
      user-select: none
      position relative
      display flex
      flex-flow row nowrap
      width 100%
      align-items flex-start
      justify-content space-between
      .now-img
        display block
        width 590px
        flex-basis @width
        .big-img-wrap
          display block
          position relative
          width 100%
          height 388px
          .pic
            display block
            width 100%
            height 100%
          .arrow
            position absolute
            cursor pointer
            top 50%
            transform translateY(-50%)
            &.left
              left 10px
            &.right
              right 10px
          .setting
            position absolute
            top 5px
            right 10px
            display flex
            align-items center
            font-size $font_size_medium
            .checkbox
              color $color_white
              margin-right 10px
            .delete
              color $color_err
              cursor pointer
              text-shadow: 0 0 5px $color_text_regular;
            .set-cover
              display flex
              align-items center
              line-height 1
              cursor pointer
              margin-right 10px
              font-size $font_size_base
              text-shadow: 0 0 5px $color_text_regular;
              .checkbox
                display flex
                width 14px
                height 14px
                align-items center
                justify-content center
                border-radius 2px
                background-color #fff
                color $color_suc
                margin-right 5px
                border 1px solid $color_suc
                &:hover
                  border 1px solid $color_suc
              .fm
                font-size 16px
                color $color_suc
          .preview-big-img
            position absolute
            bottom 0
            right 0
            display flex
            justify-content center
            align-items center
            font-size $font_size_medium
            color $color_suc
            cursor pointer
            text-shadow: 0 0 5px $color_text_regular;
            .big-icon
              font-size $font_size_medium
        .img-desc
          display flex
          justify-content space-between
          align-items flex-start
          width 100%
          color $color_white
          font-size $font_size_big
          margin 15px 0 10px
          .current
            color $color_suc
      .moment-list-wrap
        position relative
        z-index 10
        width 255px
        flex-basis @width
        height 388px
        overflow hidden
        .scroll-wrap
          position relative
          display block
          width 100%
          height 100%
          color $color_white
          overflow hidden
          .happy-scroll-strip--vertical
            right 3
          .scroll-cont
            padding-right 12px
            display flex
            flex-flow row wrap
            .mont-item
              width 118px
              height 118px
              flex-basis @width
              cursor pointer
              background-position center
              background-size cover
              background-repeat no-repeat
              &.active
                border 2px solid #ffa500
              .img
                display block
                width 100%
                height 100%
    .empty-box
      position absolute
      top: 50%;
      transform: translateY(-50%);
</style>
